import gql from "graphql-tag";
const queryGenoplotsamplesByGroup = gql(` 
query queryGenoplotsamplesByGroup($group: String!) {
  queryGenoplotsamplesByGroup(group: $group) {
      items{group sample customgroup outlier variability coords coords2 type public}
  } 
}   
`)
export default queryGenoplotsamplesByGroup;
